export interface RolesList {
  canReadBrief: string[],
  canCreateOrUpdateBrief: string[],
  canArchiveBrief: string[],
  canCopyBrief: string[],
  canReadBriefDetails: string[],
  canReadBriefDetailsComments: string[],
  canAddBriefDetailsComments: string[],
  canValidateAndAllowInSidebar: string[],
  canReadOptimization: string[],
  canSetManagers: string[],
  canSetStage: string[],
  canCreateOrUpdateCriterion: string[],
  canSetAcceptedInDevelopmentInCriterion: string[],
  canSetResolvedByModelingInCriterion: string[],
  canSetAcceptedByClientInCriterion: string[],
  canSetIsAcceptedInCriterion: string[],
  canReadCriterion: string[],
  canSetTemplateInDataset: string[],
  canSetDatasetClientConfirmed: string[],
  canSetDatasetEconometristAccepted: string[],
  canUpdateFilesInDocuments: string[],
  canDownloadFilesInDocuments: string[],
  canManageFactors: string[],
  canSetSettings: string[],
  canReadAndUpdateBriefChannels: string[],
  canCreateOrUpdateTaskChannels: string[],
  canSetTaskChannelsStatus: string[],
  canCreateOrUpdateBriefTasks: string[],
  canSetBriefTasksStatus: string[],
  canUploadFileInDataset: string[],
  canEditDataset: string[],
  canReadModel: string[],
  canEditModel: string[],
  canCreateEnginePeriod: string[],
  canCreateOptimization: string[],
  canUploadPlan: string[],
  canAcceptPlan: string[],
  canDownloadPlanFiles: string[],
  canReadDiagram: string[],
  canReadReports: string[],
}

export const rolesList: RolesList = {
  "canReadBrief": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_BRIEF_READ", "ROLE_AGENCY_ADMIN", "ROLE_MODELER", "ROLE_AGENCY_MANAGER", "ROLE_PROJECT_ADMIN"],
  "canCreateOrUpdateBrief": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_MODELER",  "ROLE_PROJECT_ADMIN", "ROLE_AGENCY_ADMIN", "ROLE_BRIEF_SAVE"],
  "canArchiveBrief": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_MODELER",  "ROLE_PROJECT_ADMIN", "ROLE_AGENCY_ADMIN", "ROLE_BRIEF_SAVE"],
  "canCopyBrief": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_MODELER",  "ROLE_PROJECT_ADMIN", "ROLE_AGENCY_ADMIN", "ROLE_BRIEF_SAVE"],
  "canReadBriefDetails": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_BRIEF_READ", "ROLE_AGENCY_ADMIN", "ROLE_MODELER", "ROLE_AGENCY_MANAGER", "ROLE_PROJECT_ADMIN"],
  "canReadBriefDetailsComments": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_COMMENT_READ", "ROLE_AGENCY_ADMIN", "ROLE_MODELER", "ROLE_AGENCY_MANAGER", "ROLE_PROJECT_ADMIN"],
  "canAddBriefDetailsComments": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_COMMENT_SAVE", "ROLE_COMMENT_SAVE", "ROLE_AGENCY_ADMIN", "ROLE_MODELER", "ROLE_AGENCY_MANAGER", "ROLE_PROJECT_ADMIN"],
  "canValidateAndAllowInSidebar": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_PROJECT_ADMIN", "ROLE_BRIEF_VALID"],
  "canSetManagers": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_PROJECT_ADMIN", "ROLE_BRIEF_MANAGER_SAVE"],
  "canSetStage": ["ROLE_ADMIN", "ROLE_MODELER",  "ROLE_PROJECT_ADMIN", "ROLE_BRIEF_STAGE_SAVE"],
  "canCreateOrUpdateCriterion": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_MODELER",  "ROLE_PROJECT_ADMIN", "ROLE_AGENCY_ADMIN", "ROLE_BRIEF_CRITERION_SAVE"],
  "canSetAcceptedInDevelopmentInCriterion": ["ROLE_ADMIN", "ROLE_MODELER",  "ROLE_PROJECT_ADMIN", "ROLE_BRIEF_CRITERION_ACCEPT"],
  "canSetResolvedByModelingInCriterion": ["ROLE_ADMIN", "ROLE_MODELER",  "ROLE_PROJECT_ADMIN", "ROLE_BRIEF_CRITERION_RESOLV"],
  "canSetAcceptedByClientInCriterion": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_MODELER",  "ROLE_PROJECT_ADMIN", "ROLE_BRIEF_CRITERION_SATISF"],
  "canSetIsAcceptedInCriterion": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_MODELER",  "ROLE_PROJECT_ADMIN", "ROLE_BRIEF_ACCEPT"],
  "canReadCriterion": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_BRIEF_READ", "ROLE_AGENCY_ADMIN", "ROLE_MODELER", "ROLE_AGENCY_MANAGER", "ROLE_PROJECT_ADMIN"],
  "canUpdateFilesInDocuments": ["ROLE_ADMIN", "ROLE_MODELER",  "ROLE_PROJECT_ADMIN", "ROLE_BRIEF_DOC_SAVE"],
  "canDownloadFilesInDocuments": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_MODELER",  "ROLE_PROJECT_ADMIN", "ROLE_AGENCY_ADMIN", "ROLE_BRIEF_DOC_READ"],
  "canManageFactors": ["ROLE_ADMIN","ROLE_MODELER",  "ROLE_PROJECT_ADMIN"],
  "canSetSettings": ["ROLE_ADMIN", "ROLE_MODELER"],
  "canReadAndUpdateBriefChannels": ["ROLE_ADMIN","ROLE_MODELER", "ROLE_BRIEF_CHANNEL_SAVE", "ROLE_AGENCY_ADMIN", "ROLE_AGENCY_MANAGER", "ROLE_PROJECT_ADMIN"],
  "canCreateOrUpdateTaskChannels": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_BRIEF_TASK_CHANNEL_SAVE", "ROLE_AGENCY_ADMIN", "ROLE_MODELER", "ROLE_AGENCY_MANAGER", "ROLE_PROJECT_ADMIN"],
  "canSetTaskChannelsStatus": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_BRIEF_TASK_CHANNEL_DATA_ACCEPT", "ROLE_MODELER", "ROLE_PROJECT_ADMIN", "ROLE_PROJECT_ADMIN"],
  "canCreateOrUpdateBriefTasks": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_BRIEF_TASK_SAVE", "ROLE_AGENCY_ADMIN", "ROLE_MODELER", "ROLE_AGENCY_MANAGER", "ROLE_PROJECT_ADMIN"],
  "canSetBriefTasksStatus": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_BRIEF_TASK_ACCEPT", "ROLE_MODELER", "ROLE_PROJECT_ADMIN"],
  "canSetTemplateInDataset": ["ROLE_ADMIN", "ROLE_MODELER",  "ROLE_PROJECT_ADMIN", "ROLE_BRIEF_TASK_FILE"],
  "canSetDatasetClientConfirmed": ["ROLE_ADMIN", "ROLE_CLIENT_ADMIN", "ROLE_BRIEF_TASK_DATA_CONFIRMED"],
  "canSetDatasetEconometristAccepted": ["ROLE_ADMIN", "ROLE_BRIEF_TASK_DATA_ACCEPTED"],
  "canUploadFileInDataset": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_MEDIA_SAVE"],
  "canEditDataset": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_BRIEF_TASK_DATA_SAVE"],
  "canReadModel": ["ROLE_ADMIN", "ROLE_ENGINE_READ", "ROLE_MODELER"],
  "canEditModel": ["ROLE_ADMIN", "ROLE_ENGINE_SAVE", "ROLE_MODELER"],
  "canCreateEnginePeriod": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_PERIOD_SAVE", "ROLE_MODELER"],
  "canReadOptimization": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_BRIEF_READ", "ROLE_PERIOD_SAVE", "ROLE_MODELER"],
  "canCreateOptimization": ["ROLE_ADMIN", "ROLE_PLAN_SAVE", "ROLE_MODELER"],
  "canUploadPlan": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_PLAN_UPLOAD", "ROLE_MODELER"],
  "canAcceptPlan": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_PLAN_ACCEPT"],
  "canDownloadPlanFiles": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_PERIOD_SAVE", "ROLE_MODELER"],
  "canReadDiagram": ["ROLE_ADMIN", "ROLE_DIAGRAM_READ", "ROLE_CLIENT_ADMIN"],
  "canReadReports": ["ROLE_CLIENT_ADMIN", "ROLE_ADMIN", "ROLE_REPORT_READ"],
};
